import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { Grid, Row, Col } from 'react-flexbox-grid';
import bem from '../../../common/bem'
import { HtmlHead, PageWrapper,PageContent, PageSection, Footer, Button, BurgerMenu} from '../../ui'

import './LandingPage.scss'

export default class LandingPage extends Component {

  static defaultProps = {
    title: 'SLS Zone'
  };

  static propTypes = {
    curMenuState: PropTypes.bool,
    onMenuChange: PropTypes.func,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    currentPath: PropTypes.string
  };

  _mountLinkList(routeStruct) {
    const children = Object.keys(routeStruct.children).map(k => routeStruct.children[k])
      .sort((a, b) => a.sort - b.sort)
      .filter(child => child.featured);

    return <ul className='link-list'>
      { children.map(child => <li key={child.url}><a href={child.url}>{child.title}</a></li> )}
    </ul>;
  }

  render() {
    const { title, routeStruct, curMenuState, onMenuChange } = this.props;
    const bemmer = bem('landingpage');

    return(
      <PageWrapper isSidebarOpen={this.props.curMenuState}>
        <HtmlHead title={title} />
        <div className="notif">Looking for the London Meetup? Get more info <a href="/pages/meetup/">here</a>.</div>
        <PageContent isRaw className={bemmer.element('container')}>
          <BurgerMenu curMenuState={curMenuState} onMenuChange={onMenuChange} className='landing'/>
          <PageSection type='primary'>
            <Row>
              <Col md={10} mdOffset={1}>
            <div className={bemmer.element('hero')}>
              <img src='/images/slszone_logo_tall.svg' />
              <h1>SLS Zone: Learn, Build and Run Serverless applications</h1>
              <p>
                SLS Zone is a collection of tutorials, best practices and open source projects created for the Serverless
                community to help build Serverless applications the right way.
              </p>
              <p style={{marginBottom:'40px'}}>
              This toolkit has evolved over countless
                hours by the Reason technology team in applying these practices to real world digital products.
                Our aim is to help grow Serverless adoption, share knowledge and help you produce reliable, scalable
                and secure digital products at speed.
              </p>
              <Button to='/pages/getting-started/' type='primary'>Get Started</Button>
            </div>
            </Col>
            </Row>
          </PageSection>
          <PageSection>
            <div className={bemmer.element('col-table')}>
              <div className='col-3 landing-col'>
                <img src='/images/icon-learn.svg' />
                <h3>Learn</h3>
                <p>
                Guides, video tutorials, and code snippets to help you get up and running on various Serverless development topics.
                </p>
                {routeStruct.learn && this._mountLinkList(routeStruct.learn)}
              </div>
              <div className='col-3 landing-col'>
                <img src='/images/icon-build.png' className={bemmer.element('img-png')} />
                <h3>Build</h3>
                <p>
                Explore our open source projects to help you streamline your delivery or learn by example.
                </p>
                {routeStruct.build && this._mountLinkList(routeStruct.build)}
              </div>
              <div className='col-3 landing-col'>
                <img src='/images/icon-run.svg' />
                <h3>Run</h3>
                <p>
                Run your product in a production environment. Follow some of the practices we use in production products.
                </p>
                {routeStruct.run && this._mountLinkList(routeStruct.run)}
              </div>
            </div>
          </PageSection>

              <PageSection type='secondary'>
              <Grid>
                <Row>
                  <Col md={8} mdOffset={2}>
                  <div className={bemmer.element('hero')}>
                    <img src='/images/icon-open-source-projects.svg' />
                    <h2>Open source projects to prevent you from re-inventing the wheel.</h2>
                    <p>Some of our default goto libraries are open for use and contribution. These libraries are staple
                      for many of our projects, are proven and tested. We are continually evolving them to meet further
                      needs, but feel free to suggest features or fork the projects for your own purposes.</p>
                    <Button to='/pages/open-source/' type='secondary'>View projects</Button>
                  </div>
                  </Col>
                </Row>
                </Grid>
              </PageSection>

          <PageSection>
            <div className={bemmer.element('hero')}>
              <img src='/images/logo-sls-zone.svg' />
              <h2>Join the online community</h2>
              <p>There’s no point going Hans Solo when we can all use the force…</p>
              <Button to='/pages/community-support/' type='tertiary'>View channels</Button>
            </div>
          </PageSection>
        </PageContent>
        <Footer />
      </PageWrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./component/page/LandingPage/LandingPage.js